import * as React from 'react';
import * as _ from 'lodash';
import Styled from './Task.style';
import { useNavigate } from 'react-router-dom';
import { Icon, ButtonClean } from '../index';
interface TaskProps {
  id: number;
  icon: string;
  title?: string;
  isDesktop: boolean;
  buttonText?: string;
  buttonPath?: string;
  completed?: boolean;

  titleWidth: string;
}
export const Task: React.FC<TaskProps> = (props) => {
  const { id, icon, title, isDesktop, buttonPath, titleWidth } = props;

  const [showPopup, setPopup] = React.useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Styled.Wrap isDesktop={isDesktop} id={id}>
        <ButtonClean
          style={{ width: '100%', textAlign: 'left', fontSize: '18px' }}
          onClick={() => {
            navigate(`${buttonPath}`);
          }}
        >
          <Styled.TextWrap>
            <Styled.Icon>
              <Icon size={80} icon={icon} />
            </Styled.Icon>
            <Styled.Title
              style={{
                fontSize: isDesktop ? '18px' : '14px',
                maxWidth: titleWidth,
              }}
            >
              {title}
            </Styled.Title>
            <Styled.ButtonWhite>Select</Styled.ButtonWhite>
          </Styled.TextWrap>
        </ButtonClean>
      </Styled.Wrap>
    </>
  );
};

export default Task;
